import { isDevMode, LOCALE_ID, NgModule, Signal, signal } from '@angular/core';
import { provideTransloco, TranslocoModule } from '@jsverse/transloco';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { provideTranslocoPersistLang } from '@jsverse/transloco-persist-lang';
import { TUI_ENGLISH_LANGUAGE, TUI_LANGUAGE, TuiLanguage } from '@taiga-ui/i18n';
import { DEFAULT_LOCALE_CODE, TRANSLOCO_LANG_STORAGE_KEY } from 'transloco.config';
import { availableLocaleCodes } from './config/available-locale-codes';
import { availableLocales } from './config/available-locales';
import { providePreloadLang } from './preload-lang-provider';
import { TranslocoHttpLoader } from './transloco-loader';
import { resolveActiveLocale } from './utils/resolve-locale';

const getAngularLocale = (): string => {
  const cachedLang = localStorage.getItem(TRANSLOCO_LANG_STORAGE_KEY);
  const cultureLang = navigator.language;
  return resolveActiveLocale({
    cachedLang,
    browserLang: cultureLang?.split('-')[0],
    cultureLang,
    defaultLang: DEFAULT_LOCALE_CODE,
  });
};

const getTuiLanguage = (): Signal<TuiLanguage> => {
  const locale = availableLocales.find((l) => l.code === getAngularLocale());
  return signal(locale?.tuiConfig.language || TUI_ENGLISH_LANGUAGE);
};

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: availableLocaleCodes,
        defaultLang: DEFAULT_LOCALE_CODE,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        flatten: {
          aot: !isDevMode(),
        },
      },
      loader: TranslocoHttpLoader,
    }),
    provideTranslocoPersistLang({
      getLangFn: resolveActiveLocale,
      storage: {
        useValue: localStorage,
      },
    }),
    providePreloadLang(),
    provideTranslocoMessageformat({
      locales: availableLocaleCodes,
    }),
    {
      provide: LOCALE_ID,
      useFactory: getAngularLocale,
    },
    {
      provide: TUI_LANGUAGE,
      useFactory: getTuiLanguage,
    },
  ],
})
export class TranslocoRootModule {}
